import React from 'react';
import ILogin from '../../../models/ILogin';
import { Field,  reduxForm, InjectedFormProps} from 'redux-form';
import ReduxFormInput from '../../../shared/components/ReduxFormHandlers/ReduxFormInput';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { FormattedMessage } from 'react-intl';
import { validatePassword, validateRequired } from '../../../helpers/validation.helper';
import userIcon from '../../../assets/Images/user32.png';
import passwordIcon from '../../../assets/Images/password32.png';

interface IProps {
  loginHandler: (data: ILogin) => void;
  isLoading: boolean;
}


let LoginForm: React.FC<InjectedFormProps<ILogin, IProps> & IProps> = props => {
  return (
    <form onSubmit={props.handleSubmit((values: ILogin) => props.loginHandler(values))} noValidate>
      <div className="form-group">
        {/* <label className="label-style float-left"><FormattedMessage id='User_Label_LoginId' /><span className="text-danger">*</span></label> */}
          <div className="input-group-prepend">
            {/* <span className="input-group-text justify-content-center">
              <img src={userIcon} alt=""></img>
            </span> */}
            <i className="fa fa-user"></i>
          </div>
          <Field
            className="form-control"
            name="username"
            component={ReduxFormInput}
            type="email"
            placeholder="User_Label_LoginId"
            min={3}
            validate={[validateRequired("User_Validation_Required_Login_Id")
            ]}
          />

      </div>
      <div className="form-group">
        {/* <label className="label-style float-left"><FormattedMessage id='User_Label_Password' /><span className="text-danger">*</span></label> */}
          <div className="input-group-prepend">
            {/* <span className="input-group-text justify-content-center">
              <img src={passwordIcon} alt=""></img>
            </span> */}
            <i className="fa fa-lock"></i>
          </div>
          <Field
            className="form-control"
            name="password"
            component={ReduxFormInput}
            type="password"
            placeholder="User_Label_Password"
            min={6}
            max={20}
            validate={[
              validateRequired("Validation_Required_Password"),
              validatePassword]}
          />
      </div>
      <div className="float-right login-btn">
        <LoaderButton type="submit" className="log-btn" isLoading={props.isLoading} text="Login" />
      </div>

    </form>

  )
};


const form = reduxForm<ILogin, IProps>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: 'LoginForm',
  enableReinitialize: true
})(LoginForm);

export default form;
